import { axios } from "../../../lib/axios";


export const getAvailablePractitioners = (orgId, scopeOfPractice) => {
    return axios.get("/practitioner?org_id=" + orgId + "&scopeOfPractice=" + scopeOfPractice);
}